export default "__VITE_PUBLIC_ASSET__0c629192__"